<template>
  <div class="project-browser">
    <project-list-item v-if="$store.getters['project/projects'].length" v-for="project in $store.getters['project/projects']" :key="(project.id + (project.workpack ? '_'+project.workpack.id : '' ))" :project="project"></project-list-item>
    <div class="p-2 text-info" v-else>No projects available</div>
  </div>
</template>

<script>
  import ProjectListItem from './ProjectListItem'
  export default {
    name: 'ProjectList',
    components: {ProjectListItem}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/projects/ProjectList.vue